module.exports = __webpack_public_path__ + "img/bnp.f515b105.png";